module.exports = __webpack_public_path__ + "img/icon-white-57.a6106054.svg";